
const statuses = {
    DRAFT: "DRAFT",
    ACTIVE: "ACTIVE",
    ARCHIVED: "ARCHIVED",
}

const statusItems = {
    [statuses.DRAFT]: {
        color: "green",
        label: "טיוטה",
    },
    [statuses.ACTIVE]: {
        color: "thirdly",
        label: "פעיל"
    },
    [statuses.ARCHIVED]: {
        color: "error",
        label: "ארכיון"
    }
}

export { statusItems }
export default statuses